import React, {useContext} from 'react';
import {NavigateFunction, useNavigate} from 'react-router-dom';
import './formotherhealthproblems.css';
import 'dayjs/locale/en';
import 'dayjs/locale/pl';
import ResultsContext from '../../../../../store/results-context';
import ButtonComponent from '../../../../shared/button/Button.component';
import CheckboxComponent from '../../../../shared/checkbox/Checkbox.component';
import {ResultsModel} from '../../../../../model/results.model';


interface FormOtherHealthProblemsProps {
    t: (key: string) => string;
}

const FormOtherHealthProblems: React.FC<FormOtherHealthProblemsProps> = ({t}: FormOtherHealthProblemsProps) => {

    const navigate: NavigateFunction = useNavigate();
    const resultsCtx: ResultsModel = useContext(ResultsContext);

    const goNextButtonText: string = t('go_next_button');
    const goBackButtonText: string = t('go_back_button');


    const goBackButtonHandler: () => void = (): void => {
        navigate('/civilization-diseases');
    }

    const goNextButtonHandler: () => void = (): void => {
        navigate('/risk-factors');
    }

    return (

        <div className="form-other-health-problems-questionnaire_main_wrapper">

            <div className="form-other-health-problems-buttons__wrapper">
                <ButtonComponent id="goBackButton"
                                 value={goBackButtonText}
                                 className="go-back_next__button"
                                 onClick={goBackButtonHandler}/>
                <ButtonComponent id="goNextButton"
                                 value={goNextButtonText}
                                 className="go-back_next__button"
                                 onClick={goNextButtonHandler}/>
            </div>

            <div className="form-other-health-problems__wrapper">


                <div className="form-other-health-problems__inner-wrapper">

                    <div className="patients_data_text margin_bottom_15">{t('info_about_patient_text')}</div>

                    <div className="form-other-health-problems_label-input__wrapper">

                        <div className="form-other-health-problems_label-input-inner__wrapper">

                            <div className="form-other-health-problems_header__wrapper">
                                {t('screen_other_health_problems')}
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="neoplasticDisease"
                                    useLightColor={true}
                                    t={t}
                                    value="neoplasticDisease"
                                    textValue={t('neoplastic_disease')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onNeoplasticDisease(value);
                                    }}
                                    checked={resultsCtx.neoplasticDisease}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="spleenDysfunction"
                                    useLightColor={true}
                                    t={t}
                                    value="spleenDysfunction"
                                    textValue={t('spleen_dysfunction')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onSpleenDysfunction(value);
                                    }}
                                    checked={resultsCtx.spleenDysfunction}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="immuneDisorders"
                                    useLightColor={true}
                                    t={t}
                                    value="immuneDisorders"
                                    textValue={t('immune_disorders')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onImmuneDisorders(value);
                                    }}
                                    checked={resultsCtx.immuneDisorders}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="immunosuppressiveDrugs"
                                    useLightColor={true}
                                    t={t}
                                    value="immunosuppressiveDrugs"
                                    textValue={t('immunosuppressive_drugs')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onImmunosuppressiveDrugs(value);
                                    }}
                                    checked={resultsCtx.immunosuppressiveDrugs}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="hivInfection"
                                    useLightColor={true}
                                    t={t}
                                    value="hivInfection"
                                    textValue={t('hiv_infection')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onHivInfection(value);
                                    }}
                                    checked={resultsCtx.hivInfection}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="boneMarrowTransplantation"
                                    useLightColor={true}
                                    t={t}
                                    value="boneMarrowTransplantation"
                                    textValue={t('bone_marrow_transplantation')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onBoneMarrowTransplantation(value);
                                    }}
                                    checked={resultsCtx.boneMarrowTransplantation}
                                />
                            </div>

                            {resultsCtx.boneMarrowTransplantation &&
                                <div className="additional-padding-left-40">
                                    <CheckboxComponent
                                        id="boneMarrowTransplantationBefore"
                                        useLightColor={true}
                                        t={t}
                                        value="boneMarrowTransplantationBefore"
                                        textValue={t('bone_marrow_transplantation_before')}
                                        onCheckHandler={(value: boolean) => {
                                            resultsCtx.onBoneMarrowTransplantationBefore(value);
                                        }}
                                        checked={resultsCtx.boneMarrowTransplantationBefore}
                                    />
                                </div>
                            }

                            {resultsCtx.boneMarrowTransplantation &&
                                <div className="additional-padding-left-40">
                                    <CheckboxComponent
                                        id="boneMarrowTransplantationAfter"
                                        useLightColor={true}
                                        t={t}
                                        value="boneMarrowTransplantationAfter"
                                        textValue={t('bone_marrow_transplantation_after')}
                                        onCheckHandler={(value: boolean) => {
                                            resultsCtx.onBoneMarrowTransplantationAfter(value);
                                        }}
                                        checked={resultsCtx.boneMarrowTransplantationAfter}
                                    />
                                </div>
                            }

                            <div>
                                <CheckboxComponent
                                    id="organTransplantation"
                                    useLightColor={true}
                                    t={t}
                                    value="organTransplantation"
                                    textValue={t('organ_transplantation')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onOrganTransplantation(value);
                                    }}
                                    checked={resultsCtx.organTransplantation}
                                />
                            </div>

                            {resultsCtx.organTransplantation &&
                                <div className="additional-padding-left-40">
                                    <CheckboxComponent
                                        id="organTransplantationBefore"
                                        useLightColor={true}
                                        t={t}
                                        value="organTransplantationBefore"
                                        textValue={t('organ_transplantation_before')}
                                        onCheckHandler={(value: boolean) => {
                                            resultsCtx.onOrganTransplantationBefore(value);
                                        }}
                                        checked={resultsCtx.organTransplantationBefore}
                                    />
                                </div>
                            }

                            {resultsCtx.organTransplantation &&
                                <div className="additional-padding-left-40">
                                    <CheckboxComponent
                                        id="organTransplantationAfter"
                                        useLightColor={true}
                                        t={t}
                                        value="organTransplantationAfter"
                                        textValue={t('organ_transplantation_after')}
                                        onCheckHandler={(value: boolean) => {
                                            resultsCtx.onOrganTransplantationAfter(value);
                                        }}
                                        checked={resultsCtx.organTransplantationAfter}
                                    />
                                </div>
                            }

                            <div>
                                <CheckboxComponent
                                    id="cochlearImplantation"
                                    useLightColor={true}
                                    t={t}
                                    value="cochlearImplantation"
                                    textValue={t('cochlear_implantation')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onCochlearImplantation(value);
                                    }}
                                    checked={resultsCtx.cochlearImplantation}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="cerebroSpinalFluidLeak"
                                    useLightColor={true}
                                    t={t}
                                    value="cerebroSpinalFluidLeak"
                                    textValue={t('cerebro_spinal_fluid_leak')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onCerebroSpinalFluidLeak(value);
                                    }}
                                    checked={resultsCtx.cerebroSpinalFluidLeak}
                                />
                            </div>

                            <div>
                                <CheckboxComponent
                                    id="autoimmuneDisease"
                                    useLightColor={true}
                                    t={t}
                                    value="autoimmuneDisease"
                                    textValue={t('autoimmune_disease')}
                                    onCheckHandler={(value: boolean) => {
                                        resultsCtx.onAutoimmuneDisease(value);
                                    }}
                                    checked={resultsCtx.autoimmuneDisease}
                                />
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>

    )
}

export default FormOtherHealthProblems;
